module.exports = "/build/images/logo.png?5045ba9d832640bc8a684729398b8ea0";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/logo.png
// module id = 2412
// module chunks = 0